import autobind from "autobind-decorator";
import { IFieldProps } from 'decorator-form';
import * as React from "react";

import CssUnitWidget from "common/form/widgets/CssUnitWidget";
import FormSection from "../../../fragments/FormSection";
import IOption from "../../../models/IOption";
import ButtonSelect from "../../widgets/common/ButtonSelect";
import ColumnsEdit from "./ColumnsEdit";

export enum LayoutType {
	COLUMN = "column",
	ROW = "row"
}

export interface IColumn {
	width: string;
	breakPoint: string;
	containerInstance: string;
}

export interface ILayout {
	type: LayoutType;
	columns: IColumn[];
}

const typeOptions: IOption[] = [
	{label: "Column", icon: "column-layout", value: LayoutType.COLUMN},
	{label: "Row", icon: "list", value: LayoutType.ROW}
];

export class LayoutField extends React.PureComponent<IFieldProps<ILayout>> {

	constructor(props: IFieldProps<ILayout>) {
		super(props);
	}

	@autobind
	private onChange(newValue: any, field: string) {
		this.props.onChange({...this.props.formData, [field]: newValue});
	}

	public render() {
		const data = this.props.formData;
		return (
			<div>
				<h4>Type</h4>
				<FormSection>
					<ButtonSelect
						readonly={false}
						autofocus={false}
						options={typeOptions}
						onChange={(v) => this.onChange(v, "type")}
						value={data.type}
					/>
				</FormSection>
				<FormSection>
					<ColumnsEdit columns={data.columns} onChange={(v) => this.onChange(v, "columns")} />
				</FormSection>
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./src/common/form/fields/layoutField/LayoutField.tsx